"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var RequiredMark_1 = require("../RequiredMark");
var ErrorMessage_1 = require("../ErrorMessage");
var styles = require("./index.module.css");
var InputGroupTitle = function (_a) {
    var _b;
    var className = _a.className, style = _a.style, children = _a.children, required = _a.required, guide = _a.guide, error = _a.error;
    return (React.createElement("div", { className: classnames_1.default(styles.inputGroupTitle, (_b = {}, _b[styles.error] = !!error, _b), className), style: style },
        React.createElement("h3", null,
            React.createElement("span", { className: styles.children }, children),
            required && React.createElement(RequiredMark_1.default, null),
            guide && React.createElement("span", { className: styles.guide }, guide)),
        React.createElement(ErrorMessage_1.default, { className: styles.errorMessage }, error)));
};
exports.default = InputGroupTitle;
